import React, { FC } from "react";
import cn from "clsx";

import { FilterOption } from "../../types";

interface SizeOptionListProps {
  options: FilterOption[];
  selectedKeys: string[];
  onOptionToggle: (option: FilterOption, e: React.MouseEvent) => void;
  isCountVisible?: boolean;
}

const SizeOptionList: FC<SizeOptionListProps> = ({
  options,
  selectedKeys,
  onOptionToggle,
  isCountVisible
}) => {
  return (
    <div className="size_chip_grid_mob">
      {options.map(option => (
        <button
          type="button"
          className={cn("size_chip_mob", {
            active: selectedKeys.includes(option.key),
            with_count: isCountVisible && option.count != null
          })}
          key={option.key}
          data-size-key={option.key}
          onClick={e => onOptionToggle(option, e)}
        >
          <span className="size_chip_mob_label">{option.label}</span>
          {isCountVisible && option.count != null && (
            <span className="size_chip_mob_count">({option.count})</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default SizeOptionList;
